import React from 'react';

const BookbindingPanel = ({
  showHoleGuides,
  setShowHoleGuides,
  numberOfHoles,
  setNumberOfHoles,
  showFoldLine,
  setShowFoldLine
}) => {
  return (
    <div className="panel-content">
      <div className="input-group">
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={showHoleGuides}
            onChange={(e) => setShowHoleGuides(e.target.checked)}
          />
          Show hole guides
        </label>
      </div>

      {showHoleGuides && (
        <div className="input-group">
          <label>
            Number of holes:
            <input
              type="number"
              min="2"
              max="10"
              value={numberOfHoles}
              onChange={(e) => setNumberOfHoles(parseInt(e.target.value))}
            />
          </label>
        </div>
      )}

      <div className="input-group">
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={showFoldLine}
            onChange={(e) => setShowFoldLine(e.target.checked)}
          />
          Show fold line
        </label>
      </div>
    </div>
  );
};

export default BookbindingPanel; 